import { useState } from 'react';
import { CheckoutFormData } from 'models/CheckoutFormData';
import connect from 'components/Shared/connect';
import { checkoutForm, isFetched } from 'views/CheckoutPage/selector';
import AutoForm from './autoForm';
import ManualForm from './manualForm';

interface OwnProps {
  reset: (quickStart: boolean) => void;
}
interface MergedProps extends OwnProps {
  quickStart: boolean;
}
const _ContactInfoPrivate = ({ quickStart, reset }: MergedProps) => {
  const [useQuickStart, setQuickStart] = useState(quickStart);
  const toggleQuickStart = () => {
    const newQuickStartValue = !useQuickStart;
    setQuickStart(newQuickStartValue);
    reset(newQuickStartValue);
  };
  const resetForm = () => {
    reset(useQuickStart);
  };

  return useQuickStart ? (
    <AutoForm resetForm={resetForm} toggleQuickStart={toggleQuickStart} />
  ) : (
    <ManualForm toggleQuickStart={toggleQuickStart} />
  );
};
type FormProps = Pick<CheckoutFormData, 'address' | 'cache' | 'quickStart'>;
interface StateProps {
  form: FormProps;
}
export const ContactInfoPrivate = connect<MergedProps, OwnProps, StateProps>(
  state => ({
    form: checkoutForm(state, 'address', 'cache', 'quickStart') as FormProps
  }),
  undefined,
  ({ form, ...state }, dispatch, props) => ({
    ...state,
    ...dispatch,
    ...props,
    quickStart: (form.cache && isFetched(form)) || form.quickStart
  })
)(_ContactInfoPrivate);
